import { initTelegram, isTelegram } from 'lib/telegram';

// Telegram Mini App bootstrap — runs once at module load, before the React
// tree mounts, so the webview is expanded and themed before first paint.
// Gated on isTelegram(): in a plain browser this file is a no-op and the app
// boots exactly as before.
if (isTelegram()) {
  initTelegram();
}

export {};
